export default __webpack_public_path__ + "locales/pl/Errors.json?hash=979a08a8841293f9c631011215cc35b4";